import { getAdminOrgId } from "lib/site";
import Logs from "screens/components/Logs";

function AdminLogs() {
    return <Logs organisationId={getAdminOrgId()}/>
}

export default AdminLogs;